module.exports = __webpack_public_path__ + "static/6-9e6ac1cb0d14aec2e938200e2ec9ebfc.mp4";